import { useCallback } from 'react';
import { useFocusEffect, useNavigation } from '@react-navigation/native';

export const useCustomScreenTitle = (title: string, shouldUsePrefix = true) => {
  const navigation = useNavigation();

  useFocusEffect(
    useCallback(() => {
      if (!title) return;

      const formattedTitle = shouldUsePrefix ? `sweetgreen: ${title}` : title;

      navigation.setOptions({ customDocumentTitle: formattedTitle });
    }, [navigation, title, shouldUsePrefix]),
  );
};
